export const isDEV = process.env.NODE_ENV === 'development'
//export const isDEV = false
export const LoginInitialValues = {
  firstName: '',
  lastName: '',
  policyNumber: '',
  birthDate: null,
}

export const TripInitialValues = isDEV
  ? {
      insuredFrom: null,
      insuredTo: null,
      travelType: 'I',
      companyName: 'Aura',
      touroperator: 'Ocean Dream',
      attachments: [],
    }
  : {
      insuredFrom: null,
      insuredTo: null,
      travelType: 'I',
      companyName: '',
      touroperator: '',
      attachments: [],
    }

/*export const ClaimantInitialValues = isDEV
  ? {
      isInsuredPerson: false,
      firstName: '',
      lastName: '',
      identification: '',
      email: 'noname@gmail.com',
      phone: '+481234579236',
      street: 'Dolna 12',
      zipCode: '00123',
      town: 'Katowice',
      country: 'POL',
    }
  : {
      isInsuredPerson: false,
      firstName: '',
      lastName: '',
      identification: '',
      email: '',
      phone: '',
      street: '',
      zipCode: '',
      town: '',
      country: 'POL',
    }*/

export const HealthProblemInitialValues = isDEV
  ? {
      occurredOn: null,
      destination: '',
      town: '',
      resort: '',
      place: '',
      hospitDateFrom: null,
      hospitDateTo: null,
      assistance: null,
      assistanceDesc: '',
      transport: null,
      transportType: '',
      description: '',
      treatmentTypes: [],
      attachments: [],
    }
  : {
      occurredOn: null,
      destination: '',
      town: '',
      resort: '',
      place: '',
      hospitDateFrom: null,
      hospitDateTo: null,
      assistance: null,
      assistanceDesc: '',
      transport: null,
      transportType: '',
      description: '',
      treatmentTypes: [],
      attachments: [],
    }

export const InsuredPersonInitialValues = {
  orderNum: 1,
  firstName: '',
  lastName: '',
  insuredRelation: '',
  birthDate: null,
}

export const CancellationInitialValues = {
  reservationDate: null,
  destination: '',
  firstPaymentDate: null,
  reason: '',
  occurredOn: null,
  insuredRelation: 'INS',
  insuredRelationOption: 'INS',
  insuredRelationSelect: '',
  description: '',
  insuredPersons: [],
  insuredPersonExists: false,
  attachments: [],
}

export const CancellationExpensesInitialValues = {
  priceCur: null,
  refundCur: null,
  currency: 'PLN',
}

export const TreatmentExpensesInitialValues = isDEV
  ? {
      orderNum: 1,
      expenseType: '',
      costDate: null,
      amount: null,
      currency: 'PLN',
      paidDirectly: null,
      attachments: [],
    }
  : {
      orderNum: 1,
      expenseType: '',
      costDate: null,
      amount: null,
      currency: 'PLN',
      paidDirectly: null,
      attachments: [],
    }

// Přesunout do initializace state, pokud jsme na DEV; jinak je initial null
/*export const BankAccountInitialValues = isDEV
  ? {
      insurance: null,
      insuranceCompany: 'AXA',
      card: null,
      bankName: 'Raffaisen',
      transfer: 'D',
      iban: '6578658',
      accountNumber: '1234 5678 12345',
      swift: '123456',
      holder: 'Marek Weselovsky',
    }
  : {
      insurance: null,
      insuranceCompany: '',
      card: null,
      bankName: '',
      transfer: 'D',
      iban: '',
      accountNumber: '',
      swift: '',
      holder: '',
    }*/

export const OverviewInitialValues = {
  agree: false,
  agree1: false,
  agree2: false,
  agree3: false,
}
